import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallListComponent } from './call-list/call-list.component';
import { AgentCatalogComponent } from './agent-catalog/agent-catalog.component';
import { AgentWizardComponent } from './agent-wizard/agent-wizard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthRequiredComponent } from './auth-required/auth-required.component';
import { KillSwitchLogsComponent } from './kill-switch-logs/kill-switch-logs.component';

const routes: Routes = [
  { path: 'auth-required', component: AuthRequiredComponent },
  { path: 'home', component: DashboardComponent, canActivate: [AuthGuard]},
  // { path: 'conversational-ai', component: ConversationalAiComponent },
  { path: 'booking-slots', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'call-list', component: CallListComponent, canActivate: [AuthGuard] },
  { path: 'agents-catalogs', component: AgentCatalogComponent, canActivate: [AuthGuard] },
  { path: 'agent/new', component: AgentWizardComponent, canActivate: [AuthGuard] },
  { path: 'agent/:id', component: AgentWizardComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'killswitch-logs', component: KillSwitchLogsComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
